// @flow strict

import * as React from 'react';
import Header from '../../components/Header';
import FeaturedItem from '../../internal/FeaturedItem';
import EventMeta from './Internal/EventMeta';
import Events from './Internal/Events';
import EmptyEvents from './Internal/EmptyEvents';
import type { EventType } from './Internal/types';

type TopPropTypes = {|
  title: string,
  subtitle: string,
  intro: string,
  featuredEvent?: EventType,
  upcomingEvents: Array<EventType>,
  subscribePardotFormUrl: string,
|};

type BottomPropTypes = {|
  pastEvents: Array<EventType>,
|};

export const EventLandingTop = (props: TopPropTypes) => (
  <>
    <Header title={props.title} subtitle={props.subtitle}>
      {props.intro}
    </Header>
    {props.featuredEvent && (
      <FeaturedItem
        title={props.featuredEvent.title}
        meta={
          <EventMeta
            startTime={props.featuredEvent.startTime}
            endTime={props.featuredEvent.endTime}
            location={props.featuredEvent.location}
          />
        }
        summary={props.featuredEvent.description}
        image={props.featuredEvent.image}
        alt={props.featuredEvent.alt}
        ctaHref={props.featuredEvent.href}
        ctaText="View details"
      />
    )}
    {props.upcomingEvents.length > 0 && <Events events={props.upcomingEvents} title="Upcoming" />}
    {props.upcomingEvents.length === 0 && !props.featuredEvent && (
      <EmptyEvents pardotFormUrl={props.subscribePardotFormUrl} />
    )}
  </>
);

export const EventLandingBottom = (props: BottomPropTypes) =>
  props.pastEvents.length > 0 && (
    <Events events={props.pastEvents} title="Read about our past events" />
  );
